import React from 'react';
import { WhiteBlock } from 'app/blocks/blocks';
import { ID, withCodes } from 'app/blocks/common/codes';
import { SubTitle } from 'app/blocks/titles/titles';
import OrdersPanelPriceInfo from 'app/pages/orders/panel/price-info';

export default withCodes(function OrdersPanelQuote({ l, prices }) {
    return (
        <WhiteBlock className="Panel p-2x">
            <SubTitle>{l('ORDER_PANELS.PANEL_QUOTE.TITLE')}</SubTitle>
            <OrdersPanelPriceInfo
                isShowTotalAmountBeforeTax
                labels={{ amountPayable: 'Total Amount' }}
                prices={prices}
            />
        </WhiteBlock>
    );
}, ID.ORDER_PANELS);
